import React, { useState, useEffect, useRef } from 'react';
import { institutions } from './institutionsData';

const ApplyButton = ({ url }) => {
  const isDisabled = !url;

  return (
    <a
      href={url || '#'}
      onClick={e => {
        if (isDisabled) e.preventDefault();
      }}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        padding: '6px 16px',
        borderRadius: 6,
        background: isDisabled ? '#ccc' : '#a05a2c',
        color: isDisabled ? '#666' : '#fff',
        fontWeight: 600,
        fontSize: 14,
        textDecoration: 'none',
        pointerEvents: isDisabled ? 'none' : 'auto',
        cursor: isDisabled ? 'default' : 'pointer',
        userSelect: 'none',
        whiteSpace: 'nowrap',
      }}
      aria-disabled={isDisabled}
      tabIndex={isDisabled ? -1 : 0}
      title={isDisabled ? 'No application URL available' : 'Apply Now'}
    >
      Apply Now
    </a>
  );
};

const InstitutionAutocomplete = ({ value, onSelect, onInputChange }) => {
  const [input, setInput] = useState(value || '');
  const [showList, setShowList] = useState(false);
  const containerRef = useRef(null);

  const matches = institutions.filter(inst =>
    inst.name.toLowerCase().includes(input.toLowerCase())
  );

  const handleChange = e => {
    setInput(e.target.value);
    if (onInputChange) onInputChange(e.target.value);
    setShowList(true);
  };

  const handleSelect = inst => {
    setInput(inst.name);
    if (onSelect) onSelect(inst);
    setShowList(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const onClickOutside = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowList(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative', maxWidth: 400 }}>
      <input
        type="text"
        aria-label="Search institutions"
        value={input}
        onChange={handleChange}
        onFocus={() => setShowList(true)}
        placeholder="Search for an institution..."
        style={{
          width: '100%',
          padding: 12,
          marginTop: 4,
          borderRadius: 8,
          border: '1px solid #c7a16c',
          fontSize: 16,
          boxSizing: 'border-box',
        }}
      />
      {showList && matches.length > 0 && (
        <ul
          role="listbox"
          style={{
            position: 'absolute',
            zIndex: 20,
            left: 0,
            right: 0,
            background: '#fff',
            border: '1px solid #c7a16c',
            borderRadius: 8,
            margin: 0,
            padding: 0,
            maxHeight: 240,
            overflowY: 'auto',
            listStyle: 'none',
            boxShadow: '0 4px 12px rgb(0 0 0 / 0.1)',
          }}
        >
          {matches.map(inst => (
            <li
              key={inst.name}
              role="option"
              onMouseDown={e => {
                // Prevent losing focus on input
                e.preventDefault();
                handleSelect(inst);
              }}
              tabIndex={-1}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
              }}
              aria-selected={input === inst.name}
              title={`${inst.name} - ${inst.type}`}
            >
              <div style={{ flex: '1 1 auto', overflow: 'hidden' }}>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 16,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#2d4b2d',
                  }}
                >
                  {inst.name}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: '#a05a2c',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {inst.type}
                </div>
              </div>
              <ApplyButton url={inst.applyUrl} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InstitutionAutocomplete;
